import React, { useState, useEffect, useRef } from "react";

function formatTime(seconds) {
  const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
  const secs = String(seconds % 60).padStart(2, "0");
  return `${mins}:${secs}`;
}

function ImageCarousel({ images, interval = 1000 }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isPlaying) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, interval);
    return () => clearInterval(timer);
  }, [images.length, interval, isPlaying]);

  const togglePlay = () => setIsPlaying(!isPlaying);

  const toggleFullscreen = () => {
    const container = containerRef.current;
    if (!document.fullscreenElement) {
      container.requestFullscreen().then(() => setIsFullscreen(true));
    } else {
      document.exitFullscreen().then(() => setIsFullscreen(false));
    }
  };

  const goTo = (index) => setCurrentIndex(index);

  return (
    <div
      ref={containerRef}
      className="carousel-container"
      style={{
        position: "relative",
        maxWidth: "800px",
        margin: "0 auto",
        padding: "20px",
        textAlign: "center"
      }}
    >
      {/* Image */}
      <img
        src={images[currentIndex].url}
        alt={`Capture ${currentIndex}`}
        style={{
          width: "100%",
          height: "auto",
          objectFit: "contain",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)"
        }}
      />

      {/* Barre de contrôle style VLC */}
      <div
        style={{
          position: "absolute",
          bottom: "0",
          left: 0,
          width: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottomLeftRadius: "10px",
          borderBottomRightRadius: "10px"
        }}
      >
        {/* Lecture / Pause */}
        <button
          onClick={togglePlay}
          style={{
            background: "none",
            border: "none",
            fontSize: "24px",
            color: "#fff",
            cursor: "pointer"
          }}
          title={isPlaying ? "Pause" : "Lire"}
        >
          {isPlaying ? "⏸️" : "▶️"}
        </button>

        {/* Barre de progression */}
        <div
          style={{
            flex: 1,
            height: "6px",
            background: "#ccc",
            margin: "0 15px",
            borderRadius: "3px",
            position: "relative",
            cursor: "pointer"
          }}
          onClick={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const percent = x / rect.width;
            goTo(Math.floor(percent * images.length));
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              height: "100%",
              width: `${(currentIndex / (images.length - 1)) * 100}%`,
              background: "#007bff",
              borderRadius: "3px"
            }}
          ></div>
        </div>

        {/* Temps */}
        <span style={{ color: "#fff", fontSize: "14px", minWidth: "75px", textAlign: "right" }}>
          {formatTime(currentIndex)} / {formatTime(images.length - 1)}
        </span>

        {/* Plein écran */}
        <button
          onClick={toggleFullscreen}
          style={{
            background: "none",
            border: "none",
            fontSize: "20px",
            color: "#fff",
            marginLeft: "10px",
            cursor: "pointer"
          }}
          title={isFullscreen ? "Quitter le plein écran" : "Plein écran"}
        >
          {isFullscreen ? "🗗" : "⛶"}
        </button>
      </div>
    </div>
  );
}

export default ImageCarousel;
